import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
    loading: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        // position: 'fixed',
        width: '100%'
    },

    loading__dot: {
        animation: `$dot ease-in-out 1s infinite`,
        backgroundColor: 'transparent',
        display: 'inline-block',
        height: '10px',
        margin: '10px',
        width: '10px',
        borderRadius: '50%',

        "&:nth-of-type(2)": {
            'animation-delay': '0.2s',
        },

        "&:nth-of-type(3)": {
            'animation-delay': '0.3s'
        }
    },

    "@keyframes dot": {
        "0%": { backgroundColor: 'transparent', transform: 'scale(1)', },
        "50%": { backgroundColor: '#fff', transform: 'scale(1.8)', },
        "100%": { backgroundColor: 'transparent', transform: 'scale(1)' }
    }
}))


function DotLoader(props) {
    const classes = useStyles();
    
    return(
        <div className={classes.loading}>
            <span className={classes.loading__dot}></span>
            <span className={classes.loading__dot}></span>
            <span className={classes.loading__dot}></span>
            {/* {React.Children.toArray(Array(3).fill(null).map(v=> <span className={classes.loading__dot}></span>))} */}
        </div>
    )
};


export default DotLoader;